import { Icon, IconProps } from "../Icon";

const MisuseAlt = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.41 23L16 17.591L10.59 23L9 21.41L14.409 16L9 10.591L10.591 9L16 14.409L21.409 9L23 10.591L17.591 16L23 21.41L21.41 23ZM2 16C2 8.26801 8.26801 2 16 2C19.713 2 23.274 3.475 25.8995 6.1005C28.525 8.72601 30 12.287 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16ZM28 16C28 9.37258 22.6274 4 16 4C9.37578 4.00771 4.00771 9.37578 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16Z"
      fill="currentColor"
    />
  </Icon>
);

export default MisuseAlt;
